const SYNCH_WITH_MYCASA = 'searchRefreshBookmarks';

export default SYNCH_WITH_MYCASA;
